import { JobStatusEnum } from '../../models/jobStatusEnum';
import { TransferStatusEnum } from '../../models/transferStatusEnum.enum';
import { DispoUser } from '../../models/user';

export function getDispoArchivedJobsQuery(
  user: DispoUser,
  { includeCancelled = false }: { includeCancelled?: boolean } = {},
): object {
  return {
    $or: [
      {
        status: {
          $in: includeCancelled
            ? [JobStatusEnum.ARCHIVED, JobStatusEnum.CANCELED]
            : [JobStatusEnum.ARCHIVED],
        },
      },
      {
        transfers: {
          $elemMatch: {
            'targetCustomer.id': user.customerId,
            status: TransferStatusEnum.ARCHIVED,
          },
        },
      },
    ],
  };
}
